import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { usePrevious } from 'react-use';
import BrowserOnly from 'components/consumer/BrowserOnly';
import { FABRIC_COLOR_CODES_MAP } from 'commons/constants';
import ProductListingColorFilter from '../../DesktopProductListingColorFilter/components/ProductListingColorFilter';
import MobileProductFilterWrapper from './MobileProductFilterWrapper';

/**
 * Color filter for mobile search filters modal.
 * Same logic as desktop (Algolia option_color + context selectedColors/selectColor),
 * compact display (grid like category page).
 */
const MobileProductListingColorFilter = t0 => {
  const $ = _c(13);
  const {
    colorFilters,
    refineColorFilters
  } = t0;
  const {
    results
  } = useInstantSearch();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.keys(FABRIC_COLOR_CODES_MAP);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== colorFilters) {
    t2 = t1.filter(c => colorFilters.some(cf => cf.label?.toLowerCase() === c));
    $[1] = colorFilters;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const colors = t2;
  const previousColors = usePrevious(colors);
  let t3;
  if ($[3] !== colors || $[4] !== previousColors || $[5] !== results?.nbHits) {
    t3 = () => {
      if (colors.length) {
        return colors;
      }
      if (results?.nbHits === 0) {
        return [];
      }
      return previousColors ?? [];
    };
    $[3] = colors;
    $[4] = previousColors;
    $[5] = results?.nbHits;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  results?.nbHits;
  let t4;
  if ($[7] !== t3) {
    t4 = t3();
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const displayColors = t4;
  if (!displayColors?.length) {
    return null;
  }
  let t5;
  if ($[9] !== colorFilters || $[10] !== displayColors || $[11] !== refineColorFilters) {
    t5 = <BrowserOnly><MobileProductFilterWrapper id="color" label="Color"><ProductListingColorFilter colors={displayColors} colorFilters={colorFilters} refineColorFilters={refineColorFilters} showAsTwoRows={true} /></MobileProductFilterWrapper></BrowserOnly>;
    $[9] = colorFilters;
    $[10] = displayColors;
    $[11] = refineColorFilters;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default MobileProductListingColorFilter;